@layer chart {
  .container {
    padding: 4px 8px;
    display: flex;
    justify-content: center;
    z-index: 1;
    position: absolute;
  }

  .label {
    text-transform: uppercase;
  }

  .badge {
    background-color: var(--background-default);
  }
}
